import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  Bold,
  ClassicEditor,
  Essentials,
  Italic,
  Link,
  List,
  Paragraph,
  Heading,
  BlockQuote,
} from "ckeditor5";
import "ckeditor5/ckeditor5.css";
import { Box, FormHelperText, InputLabel } from "@mui/material";
import { useId } from "react";

interface Props {
  label: string;
  value: string;
  onChange: (html: string) => void;
  error?: string;
}

/** The HTML the editor emits is stored verbatim, so the toolbar governs what can end up in the feed. */
export function RichTextEditor({ label, value, onChange, error }: Props) {
  const id = useId();
  return (
    <Box sx={{ mt: 2 }}>
      <InputLabel htmlFor={id} sx={{ mb: 0.5 }}>
        {label}
      </InputLabel>
      <Box
        id={id}
        sx={{
          "& .ck-editor__editable": { minHeight: 200 },
          "& .ck.ck-editor__main>.ck-editor__editable": {
            borderColor: error ? "error.main" : undefined,
          },
        }}
      >
        <CKEditor
          editor={ClassicEditor}
          config={{
            licenseKey: "GPL",
            plugins: [Essentials, Paragraph, Heading, Bold, Italic, Link, List, BlockQuote],
            toolbar: [
              "heading",
              "|",
              "bold",
              "italic",
              "link",
              "bulletedList",
              "numberedList",
              "blockQuote",
              "|",
              "undo",
              "redo",
            ],
          }}
          data={value}
          onChange={(_event, editor) => onChange(editor.getData())}
        />
      </Box>
      {error && <FormHelperText error>{error}</FormHelperText>}
    </Box>
  );
}
